import Vue from 'vue';
import axios from 'axios';
import conf from "./config";
import { isUrl } from "./tool"
import {getToken} from "./storage";
import auth from "./auth";

const openApi = ['/official/auth', '/official/jssdk', '/school-enroll'];

axios.interceptors.request.use(config => {
  let token = getToken();
  if(!isUrl(config.url) && openApi.indexOf(config.url) == -1 && !token) {
    auth();
    return Promise.reject(null);
  }
  if (!isUrl(config.url)) {
    config.url = conf.host + config.url;
  }
  let headers = {'Content-Type': 'application/json'};
  token && (headers["Authorization"] = 'Bearer ' + token.token);
  config.headers = Object.assign(config.headers, headers);
  config.loadingText !== false &&Vue.$showLoading(config.loadingText);
  return config;
}, err => {
  Vue.$toast('请求超时');
  return Promise.reject(err);
});
axios.interceptors.response.use(res => {
  Vue.$hideLoading();
  let status = res.status;
  if (status && /20[0-9]/.test(status + '')) {
    return res.data;
  }  else {
    return Promise.reject(res);
  }
}, err => {
  Vue.$hideLoading();
  if(axios.isCancel(err)) {
    console.log('Request canceled.');
  } else if(err.response) {
    let status = err.response.status;
    if(status == 401) {
      auth();
    }
  }
  return Promise.reject(err);
});

export default axios;
